import React, {Fragment, useEffect, useReducer, useRef, useState} from "react";
import { connect } from "react-redux";

import Fade from "@mui/material/Fade";

import LookAITutorialContent from "./LookAITutorialContent";
import {aiTutorialSteps, getAiStepStyles, timeoutToLaunchAiTutorial} from "./lookAITutorialConfig";
import COLOR_THEMES from "../../../../colorThemes";
import {LOOK_OVERLAYS} from "../../../look/core/constants";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {useIsMounted, usePrevious} from "../../../../misc/helperHooks";
import store from "../../../../store";


let animationTimeoutId = null;


const LookAITutorial = (props) => {

  const {visualizersLoadedLength, lookAiVisited, setLookOverlayOpened, lookOverlayOpened, lookPageOpened, lookOpened,
    isMobile} = props;

  const [showTutorial, setShowTutorial] = useState(false);
  const [aiTutorialStepIndex, setAiTutorialStepIndex] = useState(0);
  const anchorEl = useRef(null);
  const [, forceUpdate] = useReducer(x => x + 1, 0);

  const isMounted = useIsMounted();
  const prevLookOverlayOpened = usePrevious(lookOverlayOpened);

  useEffect(() => {
    if (lookAiVisited || lookOpened || lookOverlayOpened || lookPageOpened || (visualizersLoadedLength !== 1)) {
      clearTimeout(animationTimeoutId);
      return
    }
    animationTimeoutId = setTimeout(() => {
      if (isMounted() && !lookAiVisited && !lookOpened && !lookOverlayOpened) {
        const storeState = store.getState();
        if (storeState.lookState.lookOpened || storeState.lookState.lookOverlayOpened
          || storeState.lookState.lookAiVisited || storeState.lookState.lookPageOpened) {
          return
        }
        setShowTutorial(true)
      }
    }, timeoutToLaunchAiTutorial)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visualizersLoadedLength, lookAiVisited, lookOpened, lookOverlayOpened, lookPageOpened])

  const closeAiTutorial = () => {
    const scrollDiv = document.querySelector(".look-ai__content");
    if (scrollDiv) {
      scrollDiv.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
    setShowTutorial(false);
  }

  const setNextTutorialStepIndex = () => {
    const nextStep = aiTutorialStepIndex + 1;
    if (nextStep === aiTutorialSteps.length) {
      closeAiTutorial();
      return
    }
    setAiTutorialStepIndex(nextStep);
    if (nextStep === 1) {
      setLookOverlayOpened(LOOK_OVERLAYS.aiPanel);
    }
  }

  useEffect(() => {
    if (showTutorial && lookOverlayOpened === LOOK_OVERLAYS.aiPanel && (aiTutorialStepIndex === 0)) {
      setAiTutorialStepIndex(1);
    }
    if (showTutorial && lookOverlayOpened === LOOK_OVERLAYS.aiPanel && (aiTutorialStepIndex === 1)) {
      setTimeout(() => {
        forceUpdate()
      }, 0)
    }
    if (!lookOverlayOpened && showTutorial && (prevLookOverlayOpened === LOOK_OVERLAYS.aiPanel)) {
      closeAiTutorial()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lookOverlayOpened, showTutorial, aiTutorialStepIndex])

  const greenBorderClick = () => {
    if (showTutorial && aiTutorialStepIndex === 0) {
      setNextTutorialStepIndex()
    }
  }

  const {greenBorderStyles, boxStyles} = getAiStepStyles(aiTutorialStepIndex, isMobile, showTutorial);

  return (
    <Fragment>
      <Fade in={showTutorial} timeout={300} unmountOnExit>
        <div className={"aiTutorialBorder left-0 top-0 transition2" + (aiTutorialStepIndex === 0 ? " cursor-pointer" : "")}
             onClick={greenBorderClick}
             ref={anchorEl}
             style={{
          ...greenBorderStyles,
          border: "2px solid " + COLOR_THEMES.qc.active,
          position: "fixed",
          // pointerEvents: "none",
          borderRadius: "0.75rem",
          zIndex: 10500,
        }}>
          <div className={"absolute h-auto look-intro2__box look-intro2__box--with-triangle cursor-default"}
               style={boxStyles} onClick={(e) => e.stopPropagation()}>
            <LookAITutorialContent aiTutorialStepIndex={aiTutorialStepIndex}
                                   setAiTutorialStepIndex={setNextTutorialStepIndex}
                                   closeAiTutorial={closeAiTutorial}/>
          </div>
        </div>
      </Fade>
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {lookAiVisited, lookAiIntroOpened} = store.aiState;
  const {visualizersLoaded, windowHeight, isMobile} = store.serverState;
  const {lookOverlayOpened, lookOpened, lookPageOpened} = store.lookState;

  return {
    lookAiVisited,
    lookAiIntroOpened,
    visualizersLoadedLength: visualizersLoaded.length,
    lookOverlayOpened,
    lookPageOpened,
    lookOpened,
    windowHeight,
    isMobile,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookAITutorial)
